import PropTypes from 'prop-types';
import React from 'react';

import ButtonList, { ButtonListItem } from '@99designs/react-components/components/ButtonList';
import IconButton from '@99designs/react-components/components/IconButton';
import Icon from '@99designs/react-components/components/Icon';

export default class ViewControls extends React.Component {
    constructor(props) {
        super(props);

        this.handleMaximize = this.handleMaximize.bind(this);
        this.resetTimer = this.resetTimer.bind(this);
    }

    componentWillMount() {
        if (this.props.isPresentationMode) {
            window.addEventListener('mousemove', this.resetTimer, true);
            window.addEventListener('keypress', this.resetTimer, true);
            window.addEventListener('click', this.resetTimer, true);
        }
    }

    componentDidUpdate() {
        if (this.props.isPresentationMode) {
            window.addEventListener('mousemove', this.resetTimer, true);
            window.addEventListener('keypress', this.resetTimer, true);
            window.addEventListener('click', this.resetTimer, true);
        } else {
            window.removeEventListener('mousemove', this.resetTimer);
            window.removeEventListener('keypress', this.resetTimer);
            window.removeEventListener('click', this.resetTimer);
        }
    }

    componentWillUnmount() {
        window.clearTimeout(this.idleTimer);
        window.removeEventListener('mousemove', this.resetTimer);
        window.removeEventListener('keypress', this.resetTimer);
        window.removeEventListener('click', this.resetTimer);
    }

    resetTimer() {
        this.props.setIdleState(false);
        window.clearTimeout(this.idleTimer);
        this.idleTimer = window.setTimeout(() => {
            this.props.setIdleState(true);
        }, 3000);
    }

    handleMaximize() {
        this.resetTimer();
        this.props.handleMaximize();
    }

    render() {
        return (
            <div className="fullscreen-header__item--design-details">
                <ButtonList variations={['spacious']}>
                    <ButtonListItem>
                        <IconButton
                            title={this.context.intl.formatMessage({ id: 'zoom_in_tooltip' })}
                            onClick={this.props.zoomIn}
                            variations={['darker', 'on-white']}
                            isDisabled={this.props.zoomIn === null}
                        >
                            <Icon variations={['zoom-in-1', 'large']} />
                        </IconButton>
                    </ButtonListItem>
                    <ButtonListItem>
                        <IconButton
                            onClick={this.props.zoomOut}
                            title={this.context.intl.formatMessage({ id: 'zoom_out_tooltip' })}
                            variations={['darker', 'on-white']}
                            isDisabled={this.props.zoomOut === null}
                        >
                            <Icon variations={['zoom-out-1', 'large']} />
                        </IconButton>
                    </ButtonListItem>
                    <ButtonListItem>
                        {this.props.isPresentationMode ? (
                            <IconButton
                                key="minimizeBtn"
                                title={this.context.intl.formatMessage({
                                    id: 'exit_fullscreen_tooltip',
                                })}
                                variations={['darker', 'on-white']}
                                onClick={this.props.handleMinimize}
                            >
                                <Icon variations={['minimize-1', 'large']} />
                            </IconButton>
                        ) : (
                            <IconButton
                                key="maximizeBtn"
                                title={this.context.intl.formatMessage({
                                    id: 'enter_fullscreen_tooltip',
                                })}
                                variations={['darker', 'on-white']}
                                onClick={this.props.handleMaximize}
                            >
                                <Icon variations={['maximize-1', 'large']} />
                            </IconButton>
                        )}
                    </ButtonListItem>
                </ButtonList>
            </div>
        );
    }
}

ViewControls.propTypes = {
    isPresentationMode: PropTypes.bool,
    setIdleState: PropTypes.func,
    handleMinimize: PropTypes.func,
    handleMaximize: PropTypes.func,
    zoomIn: PropTypes.func,
    zoomOut: PropTypes.func,
};

ViewControls.contextTypes = {
    intl: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./~/@99designs/ddo/components/Header/ViewControls.jsx